import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { target: String, paramName: String, elementId: String }

  updateStates(event) {
    const country = event.target.value
    const frame = document.getElementById(this.targetValue)
    if (frame) {
      let url = `/locations/states?country=${country}&target=${this.targetValue}&param_name=${this.paramNameValue}`
      if (this.hasElementIdValue) {
        url += `&element_id=${this.elementIdValue}`
      }
      frame.src = url
    }
  }
}
